import { createDisplayDate } from 'owa-datetime';
/**
 * Return a display date object from minutes which is then used in rendering working hours start and end time components.
 * @minutes: minutes value corresponding to start and end time stored in calendarConfiguration
 */
var getDisplayDateFromMinutes = function (minutes) {
    return createDisplayDate(2017, 1, 1, minutes / 60, minutes % 60);
};
export default getDisplayDateFromMinutes;
//# sourceMappingURL=getDisplayDateFromMinutes.js.map